/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import React from 'react';
import { Row, Col } from 'reactstrap';
import type { User } from '#types/User.js';
import EditUserForm from './EditUserForm/index.js';

type Props = {|
  user: User,
|};

const EditUser = ({ user }: Props): null | Element<'div'> => {
  if (!user) return null;

  return (
    <div>
      <Row>
        <Col md="12">
          <h1 id="editUserHeader">Edit User</h1>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <EditUserForm user={user} />
        </Col>
      </Row>
    </div>
  );
};

export default EditUser;
